// extracted by mini-css-extract-plugin
var _1 = "NotificationContent-module__animateUploadProgressBarWidth--BfClW";
var _2 = "NotificationContent-module__animatedBackground--Ig2f9";
var _3 = "NotificationContent-module__container--_bPlO";
var _4 = "NotificationContent-module__emptyState--TABGo";
var _5 = "NotificationContent-module__image--DolmL";
var _6 = "NotificationContent-module__message--PUFlZ";
var _7 = "NotificationContent-module__sectionHeader--QBaYP";
var _8 = "NotificationContent-module__title--d2XSB";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "emptyState", _5 as "image", _6 as "message", _7 as "sectionHeader", _8 as "title" }
